import { normalizeCanonicalUrl } from '@/helpers/normalizeCanonicalUrl';
import { windowIsReady } from '@/helpers/windowIsReady';
import { DEFAULT_LOCALE } from '@/constants';
import { ENV } from '@/constants/env';
import seoImage from '@/public/seo-image.webp';

export const seoData = {
	title: 'Lift',
	description: '',
	canonical: normalizeCanonicalUrl(ENV.SEO_URL),
	openGraph: {
		type: 'website',
		locale: DEFAULT_LOCALE,
		siteName: 'Lift',
		url: windowIsReady ? window.location.href : '',
		title: 'Lift',
		description: '',
		images: [
			{
				url: seoImage.src,
				width: 800,
				height: 600,
				alt: 'Lift',
				type: 'image/webp',
			},
		],
	},
	twitter: {
		handle: '@handle',
		site: '@site',
		cardType: 'summary_large_image',
	},
};
